import "../CSS/JarvisCircle.css";

export default function JarvisCircle() {
  return (
    <div className="jarvisCircle">
      <svg width="210" height="210">
        <circle
          cx="105"
          cy="105"
          r="100"
          style={{
            fill: "transparent",
            stroke: "#B4F6FB",
            strokeWidth: 2,
            strokeDasharray: "50, 5",
          }}
        ></circle>
        <circle
          cx="105"
          cy="105"
          r="95"
          style={{
            fill: "transparent",
            stroke: "#64E6EF",
            strokeWidth: 1.5,
          }}
        ></circle>

        <circle
          cx="105"
          cy="105"
          r="80"
          style={{
            fill: "transparent",
            stroke: "#B4F6FB",
            strokeWidth: 10,
            strokeDasharray: "2,2.29",
          }}
        >
          <animateTransform
            attributeName="transform"
            attributtype="XML"
            type="rotate"
            from="0 105 105"
            to="360 105 105"
            dur="10s"
            repeatCount="indefinite"
          ></animateTransform>
        </circle>
        <circle
          cx="105"
          cy="105"
          r="61"
          transform="rotate(0 105 105)"
          style={{
            fill: "transparent",
            stroke: "#B4F6FB",
            strokeWidth: 2,
            strokeDasharray: "50,25",
          }}
        >
          <animateTransform
            attributeName="transform"
            attributtype="XML"
            type="rotate"
            from="0 105 105"
            to="-360 105 105"
            dur="10s"
            repeatCount="indefinite"
          />
        </circle>
        <circle
          cx="105"
          cy="105"
          r="50"
          style={{
            fill: "transparent",
            stroke: "#64E6EF",
            strokeWidth: 15,
            filter: "url(#light-circle)",
          }}
        ></circle>

        <path
          d="M 105 120 L 130 95 L 80 95 z"
          style={{ fill: "#D1FBFC", stroke: "#B4F6FB", strokeWidth: 5 }}
        ></path>
      </svg>
    </div>
  );
}
